import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

import bgSrc from './assets/Ellipse810.png'

export const modal = css`
  inline-size: ${spacing(58.75)};
  block-size: ${spacing(100)};
  max-block-size: calc(100% - ${spacing(6)});
  background-image: url(${bgSrc});
  background-position: bottom right;
  background-repeat: no-repeat;
  background-color: ${cssTheme.default.day.backgroundInvert};
  /* Переопределен цвет крестика закрытия модалки */
  ${cssTheme.default.day.controlMinorText.token}: ${cssTheme.default.day.textInvert};
`
export const header = css`
  margin: ${spacing(5, 6, 2, 3)};
`
export const body = css`
  margin: ${spacing(0, 6, 2, 3)};
  background-color: transparent;
  background-image: none;
`
export const image = css`
  flex: 1;
  background-position: center;
  background-repeat: no-repeat;
`

export const footer = css`
  background-color: transparent;
`
